import { createI18n } from 'vue-i18n';
import { messages } from './locales';

// Get language from URL if available
const getUrlLanguage = () => {
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('lang') || null;
  }
  return null;
};

// Get initial locale
const getInitialLocale = () => {
  // Check URL parameter first - this is the primary way to switch languages
  const urlLang = getUrlLanguage();
  if (urlLang && ['en', 'zh', 'fr'].includes(urlLang)) {
    return urlLang;
  }
  
  // Always default to English for production consistency
  // Users can add ?lang=zh to URL for Chinese
  return 'en';
};

// 创建 i18n 实例
const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages,
  globalInjection: true,
  allowComposition: true,
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  missingWarn: false,
  fallbackWarn: false,
});

// 在开发环境下验证翻译是否正确加载
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  console.log('i18n messages loaded:', {
    en_nav_contact: messages.en?.nav?.contact,
    en_brand_address: messages.en?.brand?.address,
    zh_nav_contact: messages.zh?.nav?.contact,
    zh_brand_address: messages.zh?.brand?.address
  });
}

export default i18n;
